import React from 'react'
import {Alert} from 'react-bootstrap'
import {useSelector, useDispatch} from 'react-redux'
import {hideAlert} from '../redux/reducers/alertSlice'

const CustomAlert = () => {
  const dispatch = useDispatch()
  const alert = useSelector((state) => state.alert)

  React.useEffect(() => {
    if (alert.show) {
      const timer = setTimeout(() => {
        dispatch(hideAlert())
      }, alert.timeout? alert.timeout : 4000)
      return () => clearTimeout(timer)
    }
  }, [alert, dispatch])

  const dimiss = () =>{
    dispatch(hideAlert())
  }
  return (
    alert.show && (
      <div
        className='position-fixed text-center'
        style={{
          width: window.innerWidth <= 768 ? '380px' : 'auto',
          right: '10px',
          marginTop: '5.35rem',
          overflow: 'hidden',
          zIndex: 9999
        }}
      >
        <Alert
          variant={alert.variant}
          style={
            alert.variant === 'success'
              ? {
                  backgroundColor: '#3a7846',
                  color: 'white',
                  paddingRight: '5rem',
                  paddingLeft: '5rem',
                }
              : {
                  paddingRight: '5rem',
                  paddingLeft: '5rem',
                }
          }
          {...(alert.type === 'dismissible' ? { onClose: dimiss, dismissible: true } : {})}

        >
          {alert.message}
        </Alert>
      </div>
    )
  )
}

export default CustomAlert
